import { render } from "./3d-shi.vue?vue&type=template&id=548d7fdf&scoped=true"
import script from "./3d-shi.vue?vue&type=script&lang=js"
export * from "./3d-shi.vue?vue&type=script&lang=js"

import "./3d-shi.vue?vue&type=style&index=0&id=548d7fdf&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548d7fdf"]])

export default __exports__